import React from "react";

const BLOCKED_KEYS = ["e", "E", "-"];

function MetresField({ id, label, hint, value, onChange }) {
  const hintId = `${id}-hint`;
  return (
    <div className="form-group row">
      <label htmlFor={id} className="col-sm-3 col-form-label">
        {label}
      </label>
      <div className="col-sm-9">
        <input
          id={id}
          type="number"
          min="0"
          step="any"
          className="form-control"
          value={value}
          aria-describedby={hintId}
          onKeyDown={(evt) => BLOCKED_KEYS.includes(evt.key) && evt.preventDefault()}
          onWheelCapture={(e) => e.target.blur()}
          onChange={(e) => onChange(e.target.value)}
        />
        <small id={hintId} className="form-text text-muted">
          {hint}
        </small>
      </div>
    </div>
  );
}

export default MetresField;
